import axios from 'axios';

/**
 * 获取网站名称
 * @returns {Promise<AxiosResponse<T> | never>}
 */
export const getWebInfo = () => {
  return axios.get('/ssc_golang/v1/base/product').then(info => {
    return info.data || {};
  });
};

export const getCode = () => {
  return axios.get('/ssc_golang/v1/base/code?random='+new Date().getTime()).then(info => {
    return info.data || {};
  });
};

/**
 * 获取用户信息
 * @returns {Promise<AxiosResponse<T> | never>}
 */
export const getUserInfo = () => {
  return axios.get('/ssc_golang/v1/user/userinfo').then(info => {
      //console.log("获取用户数据", info);
    return info.data || {};
  });
};


/***
 * 用户登陆
 * @param username
 * @param password
 * @param code
 * @returns {Promise<any>}
 */
export const login = ({username, password, code}) => {
  return axios.post('/ssc_golang/v1/user/login', {
    username,
    password,
    captcha: code
  });
};

export const getProfile = () => {
  return axios.get('/ssc_golang/v1/user/profile');
};

/***
 * 修改密码
 */

export const password = ({
                           old_password,
                           password,
                           password_confirm
                         }) => {
  return axios.post('/ssc_golang/v1/user/member/password', {
    old_password,
    password,
    password_confirm
  });
};

export const changeMarket = ({
  market
}) => {
return axios.post('/ssc_golang/v1/user/member/market', {
market
});
};

/***
 * 退出登录
 */
export const logout = () => {
  return axios.get('/ssc_golang/v1/user/logout');
};

//资金明细
export const getAccountLog = ({offset, limit}) => {
  return axios.get('/ssc_golang/v1/user/member/account', {
    params: {
      offset,
      limit
    }
  }).then(info => {
    if (info.result === 'ok') info.data = info.data || [];
    return info;
  });
};

// 两面常开长龙
export const getLotteryLongQueue = params => {
  return axios.get("/ssc_golang/v1/results/longqueue", { params });
};


// WEBPACK FOOTER //
// ./src/service/user.js